import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-sortable', 'sortBy', 'Rūšiuoti');
Labels.set(
    'ui-table-sortable',
    'clickToSort',
    'Spustelėkite, kad surūšiuotumėte'
);
